export default __webpack_public_path__ + "static/media/01_DAIF_Data_02_02_end.23c5469a.jpg";